__turbopack_context__.v({
  "icon": "SatributeModal-module__drbqfa__icon",
  "root": "SatributeModal-module__drbqfa__root",
  "title": "SatributeModal-module__drbqfa__title",
  "twoEmojis": "SatributeModal-module__drbqfa__twoEmojis",
});
